// src/axios.js

import axios from "axios";

const instance = axios.create({
 // baseURL: "http://localhost:8000/api",
  baseURL: "https://visennia.com/api/public/api",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;